var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"with-padding"},[_vm._v(" "+_vm._s(_vm.formatDateTime(_vm.value, 'date'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }